import { AdvertiserAccount } from '@synapex/shared2/gateway-rest-api';
import { NavigateFunction, useNavigate } from 'react-router';

import { siteMethods } from '@synapex/shared2/entities';
import { CreateSiteForm, CreateSiteFormProps } from './CreateSiteForm';
import { FormOutputValues, useCreateSiteForm } from './schema';
import { isGatewayError } from '@/shared/api/base';
import { useActiveAccountContext } from '@/true-fsd/data/advertiser-account';
import {
  useCreateSite,
  type CreateSiteOpts,
} from '@/true-fsd/data/advertiser-account/react-query';

//values
const makeAddSiteDto = ({
  site_url,
}: FormOutputValues): AdvertiserAccount.Site.CreateInputDto => {
  return siteMethods.pickTitleObj(site_url);
};

//hook
const useAddSiteToAccount = ({ onSuccess }: AddSiteToAccountProps) => {
  const { activeAccount } = useActiveAccountContext();
  const navigate = useNavigate();

  const { formState, handleSubmit, control, setError } = useCreateSiteForm();

  const { mutate } = useCreateSite(activeAccount);

  // const formHasErrors =
  //     !formState.isValid || Object.keys(formState.errors).length > 0

  const onSubmit = handleSubmit((values) =>
    mutate(makeAddSiteDto(values), {
      onSuccess: (...args) => onSuccess(navigate, ...args),
      onError: (error) => {
        console.error(error);
        //https://react-hook-form.com/docs/useform/seterror
        //Server Error
        //https://react-hook-form.com/docs/useform/handlesubmit
        //Handle submit could do this, but it doesn't
        setError('site_url', {
          message:
            (isGatewayError(error)
              ? error.response?.data.message
              : undefined) ?? 'Не удалось добавить сайт',
        });
      },
    }),
  );

  const isSubmitting = formState.isSubmitting;

  return {
    onSubmit,
    isSubmitting,
    control,
    // rootError: formState.errors.root?.message,
  };
};

export type AddSiteToAccountProps = {
  onSuccess: (
    nav: NavigateFunction,
    ...params: Parameters<NonNullable<CreateSiteOpts['onSuccess']>>
  ) => void;
} & Omit<CreateSiteFormProps, 'onSubmit' | 'isSubmitting' | 'control'>;
export const AddSiteToAccount = (props: AddSiteToAccountProps) => {
  const { RenderLayout, RenderBack } = props;
  const { onSubmit, isSubmitting, control } = useAddSiteToAccount(props);
  return (
    <CreateSiteForm
      {...{ onSubmit, isSubmitting, control, RenderLayout, RenderBack }}
    />
  );
};
